import { useEffect, useRef, useCallback, memo, useState } from "react";
import {
  GoogleMap,
  MarkerF,
  InfoWindowF,
  useJsApiLoader,
} from "@react-google-maps/api";
import "./mapContainerStyle.css";
import { Spin } from "antd";
import { mapConfig } from "../../common/constants";

type MapComponentProps = {
  lat: number;
  lng: number;
  onLocationChange: (latlng: MapComponentProps) => void;
};

const MapComponent = ({ lat, lng, onLocationChange }: MapComponentProps) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!,
  });

  const mapRef = useRef<google.maps.Map | any>(null);

  const [showMarkerInfo, setShowMarkerInfo] = useState<Boolean>(false);

  const mapOptions = {
    center: {
      lat,
      lng,
    },
    mapContainerStyle: {
      width: "100%",
      height: "500px",
    },
    options: {
      // mapTypeControl: false,
      // mapTypeId: "satellite", // , terrain, hybrid, satellite
      // fullscreenControl: false,
      // streetViewControl: false,
      // zoomControl: false,
      disableDefaultUI: true,
      draggable: true,
      // navigationControl: true,
      // panControl: true

      styles: mapConfig.mapTheme,
    },
    zoom: 14,
  };

  const markOptions = {
    icon: "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
    position: mapOptions.center,
    draggable: true,
    opacity: 0.8,
    title: "Iam Hare!", // Shows Text On Hover Marker
    label: "Click To Show The Diloge Box", // Shows Text On Marker
    visible: true,
    zIndex: 100,
    zoomControl: false,
  };

  useEffect(() => {
    if (mapRef.current) {
      window.addEventListener("resize", () => {
        google.maps.event.trigger(mapRef.current!, "resize");
        mapRef.current!.setCenter(mapOptions.center);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapRef]);

  const handleMapDragEnd = () => {
    const center: any = {
      lat: mapRef.current!.getCenter()?.lat(),
      lng: mapRef.current!.getCenter()?.lng(),
    };

    onLocationChange(center);
  };

  const handleMarkerDragEnd = (event: any) => {
    const center: any = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };

    onLocationChange(center);
  };

  const onUnmount = useCallback((map: any) => {
    mapRef.current = null;
  }, []);

  if (loadError) return <div>Map cannot be loaded, sorry.</div>;
  if (!isLoaded) return <Spin />;

  return (
    <GoogleMap
      onDragEnd={handleMapDragEnd}
      onUnmount={onUnmount}
      onLoad={(map) => {
        mapRef.current = map;
      }}
      {...mapOptions}
    >
      <MarkerF
        onClick={() => setShowMarkerInfo(true)}
        onDragEnd={handleMarkerDragEnd}
        animation={google.maps.Animation.DROP}
        {...markOptions}
      />
      {showMarkerInfo && (
        <InfoWindowF
          position={markOptions.position}
          options={{ pixelOffset: new window.google.maps.Size(0, -40) }}
        >
          <>
            <h1>Insert Your Information</h1>
            <button onClick={() => setShowMarkerInfo(false)}>ok</button>
          </>
        </InfoWindowF>
      )}
    </GoogleMap>
  );
};

export default memo(MapComponent);
